import Vue from 'vue';
import { HttpOptions } from 'vue-resource/types/vue_resource';
import * as config from '@/utils/config'
import { Issue } from '@/models/issue'
import {OidcService} from '@/services/oidc-service';

export class IssueService extends Vue{
    private oidcService: OidcService = new OidcService();

    options: HttpOptions = {
        headers: {
            'Authorization': '',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
        },
    };

    constructor() {
        super();
    }

    public async getProjectIssues(projectId: string): Promise<{data: Issue[]; meta: {totalSize: number}}> {
        this.options.headers['Authorization'] = 'Bearer ' + await this.oidcService.getAccessToken();
        return new Promise((resolve, reject) => {
            this.$http.get(config.REDANKA_BE_BASE_URL + '/projects/' + projectId + '/issues', this.options)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        console.error('Error: ', error);
                        reject(error);
                    });
        });
    }

    public async getIssueChildren(parentId: string): Promise<{data: Issue[]; meta: {totalSize: number}}> {
        this.options.headers['Authorization'] = 'Bearer ' + await this.oidcService.getAccessToken();
        return new Promise((resolve, reject) => {
            this.$http.get(config.REDANKA_BE_BASE_URL + '/projects/issue/' + parentId + '/children', this.options)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        console.error('Error: ', error);
                        reject(error);
                    });
        });
    }
}
